import { useMemo } from 'react';

import { UseOptionsQueryParams, UseOptionsQueryReturnType } from '@/components/FilterNew/types';
import useProjectStages from '@/modules/tasks/views/TasksDashboard/hooks/useProjectStages';

import { getEntityFilterGroups } from '../../../utils';
import { getProjectStageFilterOption } from '../utils';

export interface UseProjectStagesOptionsQueryParams {
  projectId?: string;
}

const useProjectStagesOptionsQuery = ({
  searchText,
  projectId,
}: UseProjectStagesOptionsQueryParams & UseOptionsQueryParams): UseOptionsQueryReturnType => {
  const { stages: initialStages, fetching, error } = useProjectStages({ projectId });

  const stages = useMemo(() => {
    if (!searchText) {
      return initialStages;
    }

    return initialStages.filter((stage) =>
      stage.name.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [searchText, initialStages]);

  const groups = useMemo(
    () => getEntityFilterGroups(stages, getProjectStageFilterOption),
    [stages],
  );

  return { error, groups, fetching };
};

export default useProjectStagesOptionsQuery;
